import { type FC } from "react";
import { Button } from "components/buttons/button/Button";

import { RolePermissions } from "../../../../../enums";
import RestrictedByTooltip from "components/restrictedByTooltip/RestrictedByTooltip";
import { useHasPermissions } from "features/Application/hooks";
import cn from "classnames";
import styles from "./removePackButton.module.scss";

export interface RemovePackButtonProps {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  className?: string;
}

const RemovePackButton: FC<RemovePackButtonProps> = ({
  disabled,
  onClick,
  text = "Remove from Account",
  className,
}) => {
  const hasPermission = useHasPermissions(RolePermissions.AccountsSettingsManage);

  return (
    <RestrictedByTooltip hasPermission={hasPermission}>
      <Button
        primary
        className={cn(styles.button, className)}
        content={text}
        onClick={onClick}
        disabled={!hasPermission || disabled}
      />
    </RestrictedByTooltip>
  );
};

export default RemovePackButton;
